import { ElMessage, ElMessageBox } from 'element-plus'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/message-box/style/css'

const MESSAGE_DEFAULTS = {
  duration: 3000,
  grouping: true
}

/** 轻量消息封装，统一默认配置；底层使用 Element Plus */
const message = {
  success(text) {
    ElMessage.success({ message: text, ...MESSAGE_DEFAULTS })
  },
  error(text) {
    ElMessage.error({ message: text, ...MESSAGE_DEFAULTS })
  },
  warning(text) {
    ElMessage.warning({ message: text, ...MESSAGE_DEFAULTS })
  },
  info(text) {
    ElMessage.info({ message: text, ...MESSAGE_DEFAULTS })
  },
  confirm(text, title = '提示', options = {}) {
    return ElMessageBox.confirm(text, title, {
      type: 'warning',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      ...options
    })
  }
}

export default message
